const PAGES = {
  PERFORMANCE_INSIGHTS: 'performance-insights',
  OVERVIEW: 'overview',
};

const PERFORMANCE_INSIGHTS_SECTIONS = {
  CORE_PERFORMANCE: 'core-performance',
  CUSTOMER_INSIGHTS: 'customer-insights',
  PROMO_CAMPAIGNS: 'promo-campaigns',
};

const OVERVIEW_SECTIONS = {
  HISTORICAL_PERFORMANCE: 'historical-performance',
};

export type AllPageSections = keyof typeof OVERVIEW_SECTIONS | keyof typeof PERFORMANCE_INSIGHTS_SECTIONS;
export type AllPageSectionsValues =
  | (typeof OVERVIEW_SECTIONS)[keyof typeof OVERVIEW_SECTIONS]
  | (typeof PERFORMANCE_INSIGHTS_SECTIONS)[keyof typeof PERFORMANCE_INSIGHTS_SECTIONS];

export interface ChartData {
  id: string;
  code: string;
  token: string;
  style?: React.CSSProperties;
  params?: { [key: string]: string };
  hideFilters?: string[];
}

export interface PageData {
  id: string;
  charts: {
    [key in AllPageSections]: ChartData[][];
  };
}

export type PageSection = PageData['charts'];

const isMetabaseChartsEnabled = () => {
  return process.env.REACT_APP_METABASE_CHARTS === 'true';
};

const getChartUrl = (token: string, params: { [key: string]: string } = {}, hideFilters: string[] = []) => {
  const defaultHideFilters = [
    'start_date',
    'end_date',
    'day_perspective',
    'outlet_id',
    'brand_id',
    'product',
    'channel',
  ];
  const hideFiltersToUse = [...defaultHideFilters, ...(hideFilters || [])];
  return `${'https://partner-dashboard.shopback.com'}/embed/question/${token}?${new URLSearchParams(
    params
  ).toString()}#downloads=false&titled=false&bordered=false&hide_parameters=${hideFiltersToUse.join(',')}`;
};

const getPageSection = <T extends AllPageSections>(pageData: PageData, section: T): PageSection[T] => {
  return pageData.charts[section] as unknown as PageSection[T];
};

const getRow = (pageSection: PageSection, row: number) => {
  return pageSection[row];
};

export {
  getChartUrl,
  getPageSection,
  getRow,
  isMetabaseChartsEnabled,
  PAGES,
  PERFORMANCE_INSIGHTS_SECTIONS,
  OVERVIEW_SECTIONS,
};
